import type { ResultName } from "./api";

function wrapText(context: CanvasRenderingContext2D, text: string, maxWidth: number): string[] {
  const lines: string[] = [];
  let current = "";
  for (const character of text) {
    const next = current + character;
    if (context.measureText(next).width > maxWidth && current) {
      lines.push(current);
      current = character;
    } else {
      current = next;
    }
  }
  if (current) lines.push(current);
  return lines;
}

export function downloadNameCard(name: ResultName, language: "zh" | "en"): void {
  const canvas = document.createElement("canvas");
  canvas.width = 1200;
  canvas.height = 1500;
  const context = canvas.getContext("2d");
  if (!context) return;
  const chinese = language === "zh";
  context.fillStyle = chinese ? "#f2eee4" : "#0a192a";
  context.fillRect(0, 0, canvas.width, canvas.height);
  context.strokeStyle = chinese ? "#a83224" : "#8dd6d0";
  context.lineWidth = 4;
  context.strokeRect(70, 70, 1060, 1360);
  context.fillStyle = chinese ? "#a83224" : "#ff6f45";
  context.font = "700 30px serif";
  context.fillText(chinese ? "结一 · 中文取名" : "JIEYI · CHINESE NAME STUDIO", 110, 145);
  context.fillStyle = chinese ? "#25221c" : "#e9e5d9";
  context.textAlign = "center";
  context.font = "700 190px serif";
  context.fillText(name.fullName, 600, 475);
  context.font = "36px serif";
  context.fillStyle = chinese ? "#756f63" : "#96abb6";
  context.fillText(name.pinyin, 600, 545);
  context.textAlign = "left";
  context.font = "46px serif";
  context.fillStyle = chinese ? "#25221c" : "#e9e5d9";
  const meaningLines = wrapText(context, name.overallMeaning, 950).slice(0, 4);
  meaningLines.forEach((line, index) => {
    context.fillText(line, 125, 690 + index * 68);
  });
  context.fillStyle = chinese ? "#a83224" : "#8dd6d0";
  context.font = "italic 39px serif";
  const quoteLines = wrapText(context, `“${name.source.quote}”`, 900).slice(0, 3);
  quoteLines.forEach((line, index) => {
    context.fillText(line, 150, 1030 + index * 60);
  });
  context.font = "26px serif";
  context.fillStyle = chinese ? "#756f63" : "#96abb6";
  context.fillText(
    `— ${name.source.dynasty} · ${name.source.author}《${name.source.title}》`,
    150,
    1240,
  );
  context.textAlign = "center";
  context.font = "24px monospace";
  context.fillText(chinese ? "name.jieyiai.dev" : "en.jieyiai.dev", 600, 1370);
  const link = document.createElement("a");
  link.download = `${name.fullName}-jieyi.png`;
  link.href = canvas.toDataURL("image/png");
  link.click();
}
